import React from "react";
import styles from "./Login/Login.module.scss";
import { FormattedMessage } from "react-intl";
import { LoadingBlock } from "./Instructions";
export function LoadingPage() {
    return (React.createElement("div", { className: styles.loginPage },
        React.createElement("div", { className: styles.panel },
            React.createElement("h2", null,
                React.createElement(FormattedMessage, { defaultMessage: "Digital artbook & soundtrack", id: "jCTuVI" })),
            React.createElement(LoadingBlock, { loading: true }))));
}
